export default __webpack_public_path__ + "static/media/Uttam Kumar Giri.866d0b58.JPG";